import React from "react";
import { func, object } from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { store } from "../store";

const SuperRoute = ({ component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      store.getState().user.authentication.data.role.id === 1 ? (
        React.createElement(component, props)
      ) : (
        <Redirect
          to={{
            pathname: "/clients",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

SuperRoute.propTypes = {
  component: func,
  location: object
};

export default SuperRoute;
